import React from "react";
import { motion } from "framer-motion";

const articlesData = [
    {
        id: 1,
        title: "AI Agents and Enterprise Identity Management: Closing the Governance Gap Securely",
        link: "#",
        textColor: "text-white"
    },
];

const InsightsSection = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 },
        },
    };

    const fadeUpVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
    };

    return (
        <section className="w-full bg-white py-12 sm:py-16 md:py-20 text-left relative z-10 overflow-hidden">
            <div className="max-w-[1280px] mx-auto w-full relative px-5 sm:px-10 lg:px-[80px] min-h-[340px] sm:min-h-[380px] md:min-h-[420px] bg-[#020A1A] p-6 sm:p-10 md:p-16 flex items-end">
                <div className="absolute inset-0 w-full h-full pointer-events-none mix-blend-screen">
                    <img
                        src="/assets/analyst/img1.png"
                        alt="Abstract futuristic blue curve mesh background"
                        className="w-full h-full object-cover object-bottom"
                    />
                </div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    className="max-w-[600px] w-full relative z-20"
                >
                    {articlesData.map((article) => (
                        <motion.div
                            key={article.id}
                            variants={fadeUpVariants}
                            className="flex flex-col justify-end items-start w-full min-w-0"
                        >
                            <h2 className={`text-[20px] md:text-[30px] font-[600] font-sora mb-5 sm:mb-6 leading-[1.3] tracking-tight break-words max-w-[540px] ${article.textColor}`}>
                                {article.title}
                            </h2>

                            <a
                                href={article.link}
                                className={`inline-flex items-center gap-2 text-[14px] sm:text-[15px] font-[600] font-graphik border-b-2 pb-0.5 transition-colors duration-300 group outline-none select-none shrink-0 ${article.textColor === "text-white"
                                    ? "text-white border-white hover:text-[#C6A997] hover:border-[#C6A997]"
                                    : "text-[#00529B] border-[#00529B] hover:text-[#ED6800] hover:border-[#ED6800]"
                                    }`}
                            >
                                <span>Read More</span>
                                <span className="transition-transform duration-300 group-hover:translate-x-1.5 text-[16px]">&gt;</span>
                            </a>
                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    );
};

export default InsightsSection;